import Button from '@app-studio-web/ui/components/Button'
import Layout from '@app-studio-web/ui/components/Layout'
import { useTranslation } from 'react-i18next'
import { Form, useSubmit } from 'react-router-dom'
import happy from '../../assets/happy.png'

export default function FeedbackResetPage() {
  const { t } = useTranslation()
  const submit = useSubmit()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <Layout>
      <div className="fixed inset-0 -z-10 bg-gradient-to-b from-[#FFFFFF] to-[#EFFBFF]" />
      <div className="flex h-full flex-col text-center">
        <div className="flex grow flex-col items-center justify-center">
          <img src={happy} alt="Happy" className="h-60 w-full sm:w-60" />

          <h1 className="custom-heading my-5 text-3xl">
            {t('pages.onboarding.feedbackReset.heading')}
          </h1>
        </div>

        <Form className="shrink-0" method="post" onSubmit={handleSubmit}>
          <Button
            title={t('pages.onboarding.feedbackReset.buttonContinue')}
            type="submit"
            dataTestId="button-continue"
          />
        </Form>
      </div>
    </Layout>
  )
}
